import { JSONParseError, TypeValidationError } from 'ai';

import { failureCause } from '~/utils/failureCause';
import { SIGNED_OUT_MESSAGE, getLeDataApiErrorMessage } from '~/utils/leData/getLeDataApiErrorMessage';

export type ChatFailureKind = 'auth' | 'unreadable' | 'server';

export interface ChatFailure {
  kind: ChatFailureKind;
  message: string;
}

export const UNREADABLE_STREAM_MESSAGE =
  'Part of this answer arrived in a form this page could not read, so I stopped there. Retry to ask again.';

export function describeChatFailure(error: unknown): ChatFailure {
  if (failureCause(error) === 'auth') {
    return { kind: 'auth', message: SIGNED_OUT_MESSAGE };
  }
  if (TypeValidationError.isInstance(error) || JSONParseError.isInstance(error)) {
    return { kind: 'unreadable', message: UNREADABLE_STREAM_MESSAGE };
  }
  return { kind: 'server', message: getLeDataApiErrorMessage(error) };
}
